<template>
  <div class="living-option-card" :class="{ 'living-option-card--active': isActive }">
    <transition name="fast-fade">
      <div v-if="isFavourited(slide._id)" class="living-option-card__fav-icon">
        <fa :icon="['far', 'heart']" />
      </div>
    </transition>
    <div class="living-option-card__slide-image">
      <!-- <transition name="fast-fade">
        <div v-if="isActive && slide.virtualTourUrl" class="living-option-card__virtual-overlay" @click="isActive ? openVirtualTour(slide.virtualTourUrl) : () => {}">
          <fa :icon="['fas', 'street-view']"/>
          <div class="text">Virtual Tour</div>
        </div>
      </transition> -->
      <img v-if="slide.dwellingOverlayImage" class="living-option-card__overlay" :src="`${$store.state.assetsPath}${slide.dwellingOverlayImage}`" />
      <img v-if="slide.packageOverlayImage" class="living-option-card__overlay" :src="`${$store.state.assetsPath}${slide.packageOverlayImage}`" />
      <img v-if="slide.images.length" :src="`${$store.state.assetsPath}${slide.images[0]}`" />
    </div>
    <div class="living-option-card__details">
      <div class="property-feature">
        <div v-if="slide.name" class="property-feature__wrapper">
          <div class="property-feature__label" :style="`color: ${config?.propertyCard?.headingColour};`">{{ slide.type === "dwelling" ? config.labels.dwellingLabel.en : config.labels.propertyLabel.en }}</div>
          <div class="property-feature__value">{{ slide.name }}</div>
        </div>

        <div v-if="slide.lotNumber" class="property-feature__wrapper">
          <div class="property-feature__label" :style="`color: ${config?.propertyCard?.headingColour};`">{{ $label(config.labels.propertyLabel) }}</div>
          <div class="property-feature__value">{{ slide.lotNumber }}</div>
        </div>

        <div v-if="$label(slide.houseDesign)" class="property-feature__wrapper">
          <div class="property-feature__label" :style="`color: ${config?.propertyCard?.headingColour};`">{{ $label(config.labels.dwellingLabel) }}</div>
          <div class="property-feature__value">{{ $label(slide.houseDesign) }}</div>
        </div>

        <div v-if="$label(slide.builder)" class="property-feature__wrapper">
          <div class="property-feature__label" :style="`color: ${config?.propertyCard?.headingColour};`">{{ $label(config.labels.dwellingBuilder) }}</div>
          <div class="property-feature__value">{{ $label(slide.builder) }}</div>
        </div>

        <div v-if="$label(slide.colourScheme)" class="property-feature__wrapper">
          <div class="property-feature__label" :style="`color: ${config?.propertyCard?.headingColour};`">Colour Scheme</div>
          <div class="property-feature__value">{{ $label(slide.colourScheme) }}</div>
        </div>

        <div v-if="slide.frontage" class="property-feature__wrapper property-feature__wrapper--frontage">
          <div class="property-feature__label" :style="`color: ${config?.propertyCard?.headingColour};`">{{ $label(config.labels.frontage) }}</div>
          <div class="property-feature__value" dir="ltr">{{ slide.frontage }}m</div>
        </div>

        <div v-if="slide.depth" class="property-feature__wrapper property-feature__wrapper--depth">
          <div class="property-feature__label" :style="`color: ${config?.propertyCard?.headingColour};`">{{ $label(config.labels.depth) }}</div>
          <div class="property-feature__value" dir="ltr">{{ slide.depth }}m</div>
        </div>

        <div v-if="slide.lotSize" class="property-feature__wrapper">
          <div class="property-feature__label" :style="`color: ${config?.propertyCard?.headingColour};`">{{ $label(config.labels.propertySize) }}</div>
          <div class="property-feature__value" dir="ltr">{{ slide.lotSize }}m<sup>2</sup></div>
        </div>

        <div v-if="slide.dwellingSize" class="property-feature__wrapper">
          <div class="property-feature__label" :style="`color: ${config?.propertyCard?.headingColour};`">{{ $label(config.labels.dwellingSize) }}</div>
          <div class="property-feature__value" dir="ltr">{{ slide.dwellingSize }}<span v-html="$label(config.labels.dwellingSizeSuffix)"></span></div>
        </div>

        <div v-if="$label(slide.viewLabel)" class="property-feature__wrapper">
          <div class="property-feature__label" :style="`color: ${config?.propertyCard?.headingColour};`">{{ $label(config.labels.viewLabel) }}</div>
          <div class="property-feature__value" dir="ltr">{{ $label(slide.viewLabel) }}</div>
        </div>

        <!-- <div v-if="slide.frontage" class="property-feature__wrapper">
          <div
            class="property-feature__label"
            :style="`color: ${config?.propertyCard?.headingColour};`"
          >{{ $label(config.labels.frontage) }}</div>
          <div class="property-feature__value" dir="ltr">{{ slide.frontage }}m</div>
        </div>    -->

        <div v-if="slide.minimumFrontage" class="property-feature__wrapper">
          <div class="property-feature__label" :style="`color: ${config?.propertyCard?.headingColour};`">Minimum Frontage</div>
          <div class="property-feature__value">{{ slide.minimumFrontage }}m</div>
        </div>

        <div v-if="config?.general?.showPrice && slide.price" class="property-feature__wrapper property-feature__wrapper--price">
          <div class="property-feature__label" :style="`color: ${config?.propertyCard?.headingColour};`">{{ priceLabel }}</div>
          <div class="property-feature__value">{{ slide.price.toLocaleString("en-AU", { style: "currency", currency: config?.currency?.code, maximumSignificantDigits: 10 }) }}</div>
        </div>

        <div class="property-feature__btn-wrapper">
          <transition name="fast-fade">
            <button v-show="isActive && slide.virtualTourUrl && isMatterportAvailable" class="btn touch" style="bottom: 2.4rem" @click.stop="openVirtualTour(slide.virtualTourUrl)">
              <span>Virtual Tour</span>
            </button>
          </transition>
          <transition name="fast-fade">
            <button v-show="isActive" class="btn touch details-button" @click.stop="openModal(slide._id)">
              <span>{{ $label(config.labels.details) }}</span>
            </button>
          </transition>
        </div>
      </div>

      <div class="dwelling-feature">
        <div v-if="slide.beds" class="dwelling-feature__wrapper">
          <div class="dwelling-feature__value">{{ slide.beds }}</div>
          <div class="dwelling-feature__icon"><fa :icon="['far', 'bed']" /></div>
        </div>
        <div v-if="slide.baths" class="dwelling-feature__wrapper">
          <div class="dwelling-feature__value">{{ slide.baths }}</div>
          <div class="dwelling-feature__icon"><fa :icon="['far', 'bath']" /></div>
        </div>
        <div v-if="slide.cars" class="dwelling-feature__wrapper">
          <div class="dwelling-feature__value">{{ slide.cars }}</div>
          <div class="dwelling-feature__icon"><fa :icon="['far', 'car']" /></div>
        </div>

        <template v-if="config?.general?.showFavourites">
          <transition name="fast-fade">
            <template v-if="isActive">
              <button v-if="!isFavourited(slide._id)" class="btn-circle btn-circle--favourites-add touch" @click.stop="addToFavourites(slide)">
                <fa :icon="['far', 'heart']" />
              </button>

              <button v-if="isFavourited(slide._id)" class="btn-circle btn-circle--favourites-remove touch" @click.stop="removeFromFavourites(slide)">
                <fa :icon="['far', 'trash']" />
              </button>
            </template>
          </transition>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { buildCarouselModalPath, buildDwellingsModalPath, buildPackagesModalPath } from "@/utils/livingRoute";
export default {
  props: ["slide", "isActive"],

  data() {
    return {
      isMatterportAvailable: false,
    };
  },

  computed: {
    ...mapGetters({
      config: "newConfig",
      language: "language",
    }),

    favourites() {
      return this.$store.getters["favourites/favourites"];
    },

    favouriteIds() {
      return this.$store.state.favourites.favouriteIds;
    },

    priceLabel() {
      let label = {};
      switch (this.slide.type.toLowerCase()) {
        case "dwelling":
        case "townhouse":
        case "terrace":
        case "villa":
        case "house":
          label = this.config.labels.dwellingPrice;
          break;
        case "package":
          label = this.slide.priceLabel || this.config.labels.packagePrice;
          break;
        default:
          label = this.config.labels.propertyPrice;
          break;
      }

      return this.$label(label);
    },
  },

  async mounted() {
    this.isMatterportAvailable = await this.fetchMatterportAvailability();
  },

  methods: {
    ...mapActions(["fetchMatterportAvailability"]),

    addToFavourites(slide) {
      this.$store.commit("favourites/ADD_TO_FAVOURITES", slide._id);
    },

    isFavourited(slideId) {
      let isFavourited = false;
      this.favouriteIds.forEach((favouriteId) => {
        if (favouriteId === slideId) {
          isFavourited = true;
        }
      });

      return isFavourited;
    },

    openModal(id) {
      const routeName = this.$store.state.route.name;

      if (routeName === "carousel") {
        this.$router.push(`${buildCarouselModalPath(this.$route, id)}${window.location.search}`);
      }

      if (routeName === "packages") {
        this.$router.push(`${buildPackagesModalPath(this.$route, id)}${window.location.search}`);
      }

      if (routeName === "dwellings") {
        this.$router.push(`${buildDwellingsModalPath(this.$route, id)}${window.location.search}`);
      }

      if (routeName === "favourites") {
        const category = this.$store.getters.activeCategory;
        this.$router.push(`/${category}/favourites/${id}?p=${this.favouriteIds.toString()}`);
      }
    },

    openVirtualTour(url) {
      this.$store.commit("property/SET_ACTIVE_VIRTUAL_TOUR_URL", url);
      this.$store.commit("sidebar/CLOSE_SLIDEOUT");
    },

    removeFromFavourites(slide) {
      this.$store.commit("favourites/REMOVE_FROM_FAVOURITES", slide._id);
    },
  },
};
</script>

<style lang="scss" scoped>
$transition-speed: 300ms;

.living-option-card {
  display: flex;
  background: #212122;
  border-radius: var(--border-radius);
  box-shadow: rgba(#000, 0.6) 0.1rem 0.2rem 0.4rem;
  flex-direction: column;
  flex-shrink: 0;
  height: auto;
  opacity: 1;
  overflow: hidden;
  position: relative;
  transition: box-shadow $transition-speed ease-in-out, opacity $transition-speed ease-in-out;
  width: 100%;

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
  }

  &__fav-icon {
    background: var(--propertymodal-label-color);
    border-radius: 0;
    border-bottom-left-radius: 0.5rem;
    color: #000;
    height: 3.5rem;
    padding: 0.65rem;
    position: absolute;
    right: -1px;
    top: -1px;
    width: 2.5rem;
    z-index: 2;

    svg {
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      font-size: 1.2rem;
    }
  }

  &__slide-image {
    aspect-ratio: 15/10;
    flex-shrink: 0;
    position: relative;
    width: 100%;

    img {
      bottom: 0;
      height: 100%;
      left: 0;
      object-fit: cover;
      position: absolute;
      right: 0;
      top: 0;
      width: 100%;
    }
  }

  &__virtual-overlay {
    align-items: center;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    pointer-events: auto;
    position: absolute;
    width: 100%;
    z-index: 1;

    svg {
      font-size: 4rem;
    }

    .text {
      font-size: 1.1rem;
      margin: 1em 0 0;
      text-transform: uppercase;
    }
  }

  &__details {
    display: flex;
    height: 100%;
    padding: 2rem;

    .dwelling-feature {
      align-items: flex-end;
      display: flex;
      flex-direction: column;
      width: 5rem;

      &__wrapper {
        align-items: center;
        display: flex;
        justify-content: center;
        margin: 0 0 1rem 0;
      }

      &__icon {
        align-items: center;
        background: var(--brand-color);
        // border: .1rem solid $brand-color;
        border-radius: 50%;
        color: var(--brand-text-color);
        display: flex;
        font-size: 1.1rem;
        justify-content: center;
        height: 2.2rem;
        width: 2.2rem;

        svg {
          color: var(--brand-text-color);
        }
      }

      &__value {
        margin: auto 0.5rem auto 0;
      }

      .btn-circle {
        border-radius: 50%;
        height: 2.4rem;
        width: 2.4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.1rem;
        margin: auto 0 0 auto;
        transform-origin: bottom left;

        &--favourites-add {
          background: var(--button-background);
          color: var(--button-color);
        }

        &--favourites-remove {
          background: var(--button-warning-background);
          color: var(--button-warning-color);
        }

        .nav-hidden & {
          display: none;
        }
      }
    }

    .property-feature {
      display: flex;
      flex-direction: column;
      width: 100%;
      // display: block;
      // position: relative;

      &__wrapper {
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        margin: 0 0 0.5rem;
      }

      &__label {
        color: var(--propertymodal-label-color);
        font-size: 0.7rem;
        text-transform: uppercase;
        margin-bottom: 0.2rem;
      }

      &__value {
        font-size: 1.1rem;
        line-height: 1.1;
        margin-bottom: 0.5rem;
      }

      &__btn-wrapper {
        align-items: flex-start;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        height: 100%;
      }

      .btn {
        background: var(--button-background);
        box-shadow: var(--button-box-shadow);
        color: var(--button-color);
        border-radius: var(--button-border-radius);
        display: block;
        padding: var(--button-padding);
        line-height: 1;
        height: var(--button-height);
        font-size: var(--button-font-size);
        text-transform: uppercase;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: scale(0.75);
        transform-origin: bottom left;
      }
    }
  }

  &__actions {
    bottom: 0.5rem;
    display: flex;
    flex-direction: column;
    margin: auto 0 0;
    opacity: 1;
    padding: 0 2rem;
    position: absolute;
    transform: scale(0.75);
    transition: transform $transition-speed ease-in-out;
    width: 100%;

    .btn {
      margin: 0 auto 1.25em;
      width: 100%;

      &:last-child {
        margin: 0 auto;
      }
    }
  }
}

.details-button {
  .nav-hidden & {
    display: none;
  }
}
</style>
